import { v4 as uuidv4, validate } from "uuid";
export const isValidUUID = (str) => validate(str);
export const randomUUID = () => uuidv4();
